import { useFeatureFlag } from '@zip/feature-flag-react';
import { FeatureFlag } from '../enums';

export const useFeatureFlagEnabled = (featureFlag: FeatureFlag): boolean => {
  const rawFeatureFlag = useFeatureFlag(featureFlag);
  const key = rawFeatureFlag?.key;
  return key === 'on' || key === 'true' || key === 'on_with_banner';
};

export const useFeatureFlagPayload = <T>(featureFlag: FeatureFlag): T => {
  const rawFeatureFlag = useFeatureFlag(featureFlag);

  return rawFeatureFlag?.payload as T;
};
